var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-box"},[_c('avatar',{staticClass:"avatar",attrs:{"imgSrc":_vm.serverAvatar}}),_c('span',{staticClass:"text-message",domProps:{"innerHTML":_vm._s(_vm.item.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }